<template>
  <v-slide-y-reverse-transition>
  <v-container class="progress-card px-0">
    <div
      style="border-radius: 30px;"
      class="footerblue"
    >
      <v-row align="center" class="px-3">
        <v-col cols="2" class="d-flex justify-start px-2">
          <v-btn
            v-show="showPrevious"
            class="lightblue--text"
            icon
            @click="previous()"
            id="previous-btn"
          >
            <v-icon size="50px">{{previousIcon}}</v-icon>
          </v-btn>
        </v-col>

        <v-col>
          <div v-if="content==='text'" class="text-center">
            <mrx-translation :token=barText></mrx-translation>
          </div>
          <div
            v-else-if="content==='step'"
            class="d-flex justify-center"
          >
            <div
              v-for="(step, index) in steps"
              :key=index
              class="progress-dot lightblue mx-2"
              :class="step ? '' : 'faded'"
            ></div>
          </div>
          <div v-else-if="content==='bar'">
            <v-progress-linear
              :value="progressPercent"
              color="lightblue"
              rounded
            ></v-progress-linear>
          </div>
          <div v-else>
            Other Type
          </div>
        </v-col>

        <v-col cols="2" class="d-flex justify-end px-2">
          <v-slide-x-transition hide-on-leave>
          <v-btn
            v-show="ready"
            class="lightblue--text"
            icon
            @click="next"
            id="next-btn"
          >
            <v-icon size="50px">{{nextIcon}}</v-icon>
          </v-btn>
          </v-slide-x-transition>
        </v-col>
      </v-row>
    </div>
  </v-container>
  </v-slide-y-reverse-transition>
</template>

<script>
  import icons from '@/mixins/icons'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    mixins: [icons],
    data() {
      return {}
    },
    methods: {
      next() {
        switch(this.$route.name) {
          case 'Location':
            this.locationNext(this.navigateNext);
            break;
          default:
            this.navigateNext();
            break;
        }
      },
      ...mapActions({
        locationNext: 'v4/location/next',
        navigateNext: 'v4/navigate/next',
        previous: 'v4/navigate/previous',
      })
    },
    computed: {
      previousIcon() {
        return this.$vuetify.rtl ? this.icons.mdiChevronRight : this.icons.mdiChevronLeft
      },
      nextIcon() {
        return this.$vuetify.rtl ? this.icons.mdiChevronLeft : this.icons.mdiChevronRight
      },
      content() {
        let content = 'text' // text is for views like summary, treatment, careplan

        switch (this.$route.name) {
          case 'Preference':
            content = 'step'; // step is for engagement preferences
            break;
          case 'Panel':
            if (!this.editResponsesMode) {
              content = 'bar'; // bar is for assessment panels
            }
            break;
          default:
            break;
        }

        return content;
      },
      steps() {
        // returns an array of values for dots, where true indicates it is selected
        let arr = new Array(this.prefOrder.total).fill(false)
        arr[this.prefOrder.ind] = true
        return arr
      },
      progressPercent() {
        // returns percent full for given track
        return this.panelOrder
      },
      barText() {
        // placeholder - returns text for bottom bar
        let key = '';

        switch(this.$route.name) {
          case 'Summary':
            if (this.$route.meta.collection === 'preference') {
              key = 'app.summary.user.title';
            } else {
              key = 'app.summary.title';
            }
            break;
          case 'Triage':
            key = 'care.category.triage';
            break;
          case 'Treatment':
            key = 'care.category.treatment';
            break;
          case 'Careplan':
            key = 'app.careplan.title';
            break;
          case 'Language':
            key = 'app.nav.menu.language.title';
            break;
          case 'Location':
            key = 'app.summary.location.title';
            break;
          case 'StreamlinedOption':
            key = 'app.streamlined.title';
            break;
          case 'Panel':
            if (this.editResponsesMode) {
              key = 'app.edit_responses.title';
            }
            break;
          case 'UserInterface':
              key = 'app.summary.user_interface.title';
              break;
          default:
            break;
        }

        return key;
      },
      ...mapGetters({
        ready: 'v4/navigate/ready',
        showPrevious: 'v4/navigate/showPrevious',
        prefOrder: 'v4/preference/getOrder',
        panelOrder: 'v4/panel/getOrder',
        editResponsesMode: 'v4/track/editResponsesMode',
      })
    }
  }
</script>
<style type="text/css">
  .progress-card {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    max-width: inherit;
    width: 90%;
    z-index: 5;
  }
  .progress-dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
  }
  .faded {
    opacity: 0.3;
  }
</style>
